import { useQueryWithUserId } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';
import { IAssetGroupQueryParams } from '../types';

/**
 * This is to track the asset groups from the backend.
 */
const ASSET_GROUP_QUERY_KEY = 'asset-groups-query-key';

/**
 * This hook fetches a list of asset groups under a specific category and brand.
 */
export const useAssetGroupQuery = (params: IAssetGroupQueryParams) => {
  const { categoryId, brandIds } = params;
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [ASSET_GROUP_QUERY_KEY, categoryId, brandIds],
    networkMode: 'always',
    queryFn: () => USER_REGISTRATION_API.searchAssetGroups(params),
    enabled: !!categoryId,
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
